import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    IconButton,
    Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { IImportErrorResponse } from '../../../../model/scp/purchase-item-import/response/import-error-response';

export interface IPurchaseItemImportErrorsDialogProps {
    open: boolean;
    onClose: () => void;
    errors: IImportErrorResponse[];
    successCount?: number;
    totalCount?: number;
}

export default function PurchaseItemImportErrorsDialog({
    open,
    onClose,
    errors,
    successCount = 0,
    totalCount = 0
}: IPurchaseItemImportErrorsDialogProps) {
    const errorCount = errors.length;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Resultado da Importação
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 3 }}>
                    {successCount > 0 && (
                        <Alert severity="success" icon={<CheckCircleOutlineIcon />} sx={{ mb: 2 }}>
                            <Typography variant="body1">
                                <strong>{successCount}</strong> {successCount === 1 ? 'item importado' : 'itens importados'} com sucesso!
                            </Typography>
                        </Alert>
                    )}

                    {errorCount > 0 && (
                        <Alert severity="error" icon={<ErrorOutlineIcon />}>
                            <Typography variant="body1">
                                <strong>{errorCount}</strong> {errorCount === 1 ? 'erro encontrado' : 'erros encontrados'}
                            </Typography>
                        </Alert>
                    )}
                </Box>

                {errorCount > 0 && (
                    <>
                        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            Detalhes dos Erros
                        </Typography>
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <strong>Linha</strong>
                                        </TableCell>
                                        <TableCell>
                                            <strong>Campo</strong>
                                        </TableCell>
                                        <TableCell>
                                            <strong>Mensagem</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {errors.map((error, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{error.line}</TableCell>
                                            <TableCell>{error.field || '-'}</TableCell>
                                            <TableCell>{error.message || 'Erro não especificado'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
